import { Language } from '@/core';

export const getLanguageVariantByDefaultPriority = (language: Language) => {
  if (language.cs) {
    return language.cs;
  }
  if (language.en) {
    return language.en;
  }
  if (language.de) {
    return language.de;
  }
  return '';
};
